import { render, staticRenderFns } from "./PatLoginPage.vue?vue&type=template&id=3f3bdac4"
import script from "./PatLoginPage.vue?vue&type=script&lang=js"
export * from "./PatLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports